import { TefComs4p } from '@mfe/components/TefComs4p';
import { html } from 'lit';

// This is just for testing
export const forTesting = function render(this: TefComs4p) : ReturnType<typeof html> {
  return html`<p>${this.loadedResourcesCount}</p>`;
};
